'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var styled = require('styled-components');
var index = require('../core/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Icon = styled__default['default'].i.attrs(function (props) {
  return {
    className: props.icon
  };
})(_templateObject(), index.styleEngine, function (props) {
  return props.badge ? "\n  &:after {\n    content: '';\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    background: #fa6581;\n    border-radius: 50%;\n    height: 8px;\n    width: 8px;\n  }\n  " : '';
});

exports.default = Icon;
